// +----------------------------------------------------------------------
// | Desc:全局注册自定义公共插件
// +----------------------------------------------------------------------
import Vue from 'vue'

// +----------------------------------------------------------------------
// | Desc:框架集
// +----------------------------------------------------------------------
import layout from '@/layout/pages/layout/layout' 
Vue.component('layout', layout)

// +----------------------------------------------------------------------
// | Desc:框架集
// +----------------------------------------------------------------------
import layoutB from '@/layout/pages/layout/layoutB' 
Vue.component('layoutB', layoutB)

// +----------------------------------------------------------------------
// | Desc:上传插件
// +----------------------------------------------------------------------
import QHupload from './QHupload'
Vue.component('QHupload', QHupload)

// +----------------------------------------------------------------------
// | Desc:日期插件
// +----------------------------------------------------------------------
import QHdatePicker from './QHdatePicker'
Vue.component('QHdatePicker', QHdatePicker)

// +----------------------------------------------------------------------
// | Desc:复选框插件
// +----------------------------------------------------------------------
import QHcheckboxGroup from './QHcheckboxGroup'
Vue.component('QHcheckboxGroup', QHcheckboxGroup)

// +----------------------------------------------------------------------
// | Desc:下拉筛选框 
// +----------------------------------------------------------------------
import QHtreeselect from './QHtreeselect'
Vue.component('QHtreeselect', QHtreeselect)

// +----------------------------------------------------------------------
// | Desc:文件列表
// +----------------------------------------------------------------------
import QHfileList from './QHfileList'
Vue.component('QHfileList', QHfileList)

// +----------------------------------------------------------------------
// | Desc:图标选择
// +----------------------------------------------------------------------
import QHiconselect from './QHiconselect/QHiconselect'
Vue.component('QHiconselect', QHiconselect)

// +----------------------------------------------------------------------
// | Desc:按钮组件
// +----------------------------------------------------------------------
import QHButton from './QHButton'
Vue.component('QHButton', QHButton)

// +----------------------------------------------------------------------
// | Desc:城市选择组件(多选)
// +----------------------------------------------------------------------
import QHcitySelectMore from './QHcitySelectMore/QHcitySelectMore'
Vue.component('QHcitySelectMore', QHcitySelectMore)

// | Desc:城市选择组件(单选)
// +----------------------------------------------------------------------
import QHcitySelect from './QHcitySelect/QHcitySelect'
Vue.component('QHcitySelect', QHcitySelect)

// +----------------------------------------------------------------------
// | Desc:二级树状选择器
// +----------------------------------------------------------------------
import QHcheckboxTree from './QHcheckboxTree'
Vue.component('QHcheckboxTree', QHcheckboxTree)

// +----------------------------------------------------------------------
// | Desc:图片列表弹出层
// +----------------------------------------------------------------------
import QHImgList from './QHImgList'
Vue.component('QHImgList', QHImgList)

// +----------------------------------------------------------------------
// | Desc:分页列表
// +----------------------------------------------------------------------
import QHTable from './QHTable'
Vue.component('QHTable', QHTable)

// +----------------------------------------------------------------------
// | Desc:按钮下拉操作
// +----------------------------------------------------------------------
import QHSelectBtn from './QHSelectBtn'
Vue.component('QHSelectBtn', QHSelectBtn)

// +----------------------------------------------------------------------
// | Desc:远程搜索下拉
// +----------------------------------------------------------------------
import QHonlineSelect from './QHonlineSelect'
Vue.component('QHonlineSelect', QHonlineSelect)

// +----------------------------------------------------------------------
// | Desc:滑块验证
// +----------------------------------------------------------------------
import QHslideverify from './QHslideverify/QHslideverify'
Vue.component('QHslideverify', QHslideverify)

// +----------------------------------------------------------------------
// | Desc:左侧城市选择
// +----------------------------------------------------------------------
import QHleftcity from './QHleftcity/QHleftcity'
Vue.component('QHleftcity', QHleftcity)

// +----------------------------------------------------------------------
// | Desc:数据加载层
// +----------------------------------------------------------------------
import QHloading from './QHloading/QHloading'
Vue.component('QHloading', QHloading)


// +----------------------------------------------------------------------
// | Desc:开发器
// +----------------------------------------------------------------------
import QHdev from './QHdev/QHdev'
Vue.component('QHdev', QHdev)





